function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3277_41352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.466 2.40234H3.86602C2.59342 2.40234 1.95712 2.40234 1.56202 2.76857C1.16692 3.1348 1.16602 3.72502 1.16602 4.90459V5.51793C1.16602 6.43972 1.16602 6.90106 1.40002 7.28329C1.63402 7.66551 2.05972 7.90374 2.91382 8.37841L5.53552 9.8362C6.10792 10.1544 6.39502 10.3135 6.60022 10.4895C7.02682 10.8549 7.28962 11.2851 7.40842 11.814C7.46602 12.0664 7.46602 12.3633 7.46602 12.9562V15.3296C7.46602 16.1376 7.46602 16.5421 7.69282 16.8567C7.91962 17.1723 8.32282 17.3278 9.12742 17.639C10.8185 18.2914 11.6636 18.6176 12.2648 18.2461C12.866 17.8745 12.866 17.0265 12.866 15.3287V12.9553C12.866 12.3633 12.866 12.0664 12.9236 11.8131C13.0366 11.295 13.3214 10.829 13.7327 10.4887C13.937 10.3135 14.2241 10.1544 14.7965 9.83531L17.4182 8.37752C18.2714 7.90374 18.6989 7.6664 18.932 7.28417C19.166 6.90195 19.166 6.43972 19.166 5.51704V4.9037C19.166 3.72503 19.166 3.1348 18.77 2.76857C18.3758 2.40234 17.7395 2.40234 16.466 2.40234Z",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3277_41352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.166016 0.402344)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9619464cc68171df64800bf6d634f860.svg";
export { ForwardRef as ReactComponent };